import type { DynamicFormV2Palette } from "@mui/material";

import type { CanvasBackgroundTheme } from "./canvasBackgroundTheme";

export function mapFormThemeToCanvasBackgroundTheme({
  mode,
  isDullMode,
}: {
  formsPalette: DynamicFormV2Palette["forms"];
  mode: "light" | "dark";
  isDullMode: boolean;
}): CanvasBackgroundTheme {
  if (mode === "light") {
    return isDullMode ? "lightdull" : "light";
  }
  return isDullMode ? "darkdull" : "dark";
}
